<template>
	<div class="detail-wrap">
		<el-form ref="editForm" :model="brand">
			<div class="d-header clearfix">
				<div class="fl">
					<i class="el-icon-info" />
					{{ dataId ? '查看' : '新增' }}厂商品牌
				</div>
				<div class="fr">
					<el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button>
					<el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
				</div>
			</div>
			<div class="d-cont edit-mce-box">
				<div class="d-item">
					<div class="title first"><b>基本信息</b></div>
					<table class="table-detail">
						<tbody>
							<tr>
								<th>
									<em class="f-red">*</em>
									品牌名称
								</th>
								<td>
                  <el-input type="text" autocomplete="off" v-model="brand.brandName" clearable />
								</td>
								<th>状态</th>
								<td>
                  <el-form-item prop="usable" :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="brand.usable" >
                      <el-option  label="禁用" :value="0" />
                      <el-option  label="启用" :value="1" />
                    </el-select>
                  </el-form-item>
                </td>
							</tr>
              <tr>
                <th>品牌图片</th>
                <td colspan="7">
                  <el-input type="hidden"  v-model="brand.pic"  />
                  <uploadViewDialog  @getUploadPic='getPic' :pic="brand.pic"></uploadViewDialog></td>
              </tr>
							<tr>
								<th>备注</th>
								<td colspan="4">
									<el-input type="textarea" :rows="2" placeholder="请输入内容" size="small" v-model="brand.remark" clearable></el-input>
								</td>
							</tr>
							<tr>
								<th>创建人</th>
								<td>{{ brand.createBy }}</td>
								<th>创建时间</th>
								<td>{{ brand.createTime }}</td>
								<th>更新人</th>
								<td>{{ brand.modifyBy }}</td>
								<th>更新时间</th>
								<td>{{ brand.modifyTime }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
import request from "../../../router/axios";
import uploadViewDialog from '../../../components/upload/oneView'
export default {
	name: 'brandEdit',
	props: {
		_dataId: [String, Number]
	},
	components: {
    uploadViewDialog,
	},
	data() {
		return {
			lan: 'zh_CN',
			isEdit: false,
			tabIndex: 'first',
			dataId: '',
			brand: { usable: 1,pic:"" },
      pic:'',
		};
	},
	computed: {
	},
	created() {
		if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			if (this.dataId && !isNaN(this.dataId)) {
				this.isEdit = true;
        request({
          url: '/basic/snCompanyBrand/get',
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.brand = response.data.objx || {};
          this.pic = response.data.objx.pic ||  '';
        })
			} else {
			}
		},
		saveData() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					this.$baseConfirm('您确定要保存吗？').then(() => {
						var url = (this.isEdit ? `/basic/snCompanyBrand/update` : `/basic/snCompanyBrand/save`);
            request({
              url: url,
              method: 'post',
              data: this.brand,
              isLoading: true,
              modalStrictly: true,
            }).then(response => {
              this.$message({
                message: response.data.content,
                type: 'success',
                duration: 500,
                onClose: t => {
                  if (this.isEdit) {
                    this.$baseReload();
                  } else {
                    this.$baseReload({
                      updateParam: {
                        _dataId: response.data.objx
                      }
                    });
                  }
                }
              });
            })
					});
				}
			});
		},
		confirmCategory(rows) {
			if (rows.length > 0) {
				let row = rows[0];
			}
		},
    getPic(data){
      this.brand.pic = data;
    }
	}
};
</script>
